import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    var validateNum = function validateNum(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入账号'));
      } else {
        // if (!/^(?!.*\s)([a-zA-Z0-9_-]{6,40}|[a-zA-Z0-9._%+-]{1,30}@[a-zA-Z0-9.-]{1,30}\.[a-zA-Z]{2,})$/.test(value)) {
        //   callback(new Error('账号格式不正确'));
        // }
        // if (!/^[a-zA-Z0-9\._%+-]{1,20}@[a-zA-Z0-9\.-]{1,15}\.[a-zA-Z]{1,5}$/.test(value)) {
        //   callback(new Error('账号格式不正确'));
        // }
        if (!/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]{6,30}$/.test(value)) {
          callback(new Error('账号必须由字母和数字组成，长度6-30位'));
        }

        callback();
      }
    };

    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        account: ""
      },
      rules: {
        // account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        account: [{
          required: true,
          validator: validateNum,
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                if (data) {
                  _this.formData.id = data.id;
                  _this.formData.appid = data.appid;
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetVaildate: function resetVaildate() {
      this.$refs.ruleForm.validateField('account');
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 6;
                    break;
                  }

                  data = JSON.parse(JSON.stringify(_this2.formData));
                  data.account = JSON.stringify(data.account);

                  _this2.$api.updAccountInfo(_objectSpread(_objectSpread({}, data), {}, {
                    isMustAppid: 1
                  })).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  });

                  _context2.next = 7;
                  break;

                case 6:
                  return _context2.abrupt("return", false);

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};